import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Box, Text, Stack, Image, Divider, HStack, useMultiStyleConfig} from '@chakra-ui/react'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {FormattedMessage} from 'react-intl'
import {remCalc} from '../../theme/_utils'
import VatLabel from '../../components/vat-label'
import UnitPrice from '../../pages/cart/partials/unit-price'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {findImageGroupBy} from '@salesforce/retail-react-app/app/utils/image-groups-utils'
import {useProduct} from '@salesforce/commerce-sdk-react'
import QuantityPicker from '../quantity-picker'

const SubscriptionCancelItemCard = ({item, showDivider = false}) => {
    const {currency} = useCurrency()
    const {locale} = useMultiSite()
    const styles = useMultiStyleConfig('Subscriptions')

    // Fallback image logic
    const shouldFetchProduct = item?.ProductCode && !item?.ItemImage__c
    const {data: product} = useProduct(
        {
            parameters: {
                id: item?.ProductCode,
                expand: ['images', 'variations'],
                locale: locale.id,
                currency,
                allImages: true,
            },
        },
        {
            enabled: !!shouldFetchProduct,
        },
    )
    const image =
        product &&
        findImageGroupBy(product?.imageGroups, {
            viewType: 'large',
            selectedVariationAttributes: product?.variationValues,
        })?.images?.[0]
    const imageUrl =
        item?.officinaConfigurationImage__c ||
        item?.ItemImage__c ||
        image?.disBaseLink ||
        image?.link

    return (
        <>
            <Flex align="flex-start" gap={remCalc(24)}>
                <Image src={imageUrl} alt={item?.Name} boxSize={remCalc(120)} objectFit="contain" />
                <Box flex="1">
                    <Stack spacing={remCalc(4)}>
                        <Text {...styles.assistanceTitle}>{item?.Name}</Text>
                        {item?.ProductCode && (
                            <Text {...styles.itemCode}>SKU {item.ProductCode}</Text>
                        )}
                        <UnitPrice
                            currency={item?.CurrencyIsoCode || currency}
                            orderDetail={{
                                UnitPrice:
                                    item?.ListPrice || item?.TotalAmtWithTax || item?.UnitPrice,
                            }}
                        />
                        {item?.TotalTaxAmount && (
                            <HStack mt="12px">
                                <VatLabel
                                    amount={item?.TotalTaxAmount / (item?.Quantity || 1)}
                                    fixedCurrency={item?.CurrencyIsoCode}
                                    vatRate={
                                        ((item?.TotalTaxAmount || 0) /
                                            ((item?.TotalAmtWithTax || 0) -
                                                (item?.TotalTaxAmount || 0))) *
                                        100
                                    }
                                    variant="OrderDetail"
                                />
                            </HStack>
                        )}
                        <Flex align="center" gap="12px" mt="12px">
                            <Text as="span" fontSize="12px">
                                <FormattedMessage
                                    id="product_item.label.quantity"
                                    defaultMessage="Quantity"
                                />
                            </Text>
                            <QuantityPicker
                                value={item?.Quantity || 1}
                                hideIncDecButtons={true}
                                variant={'OrderDetail'}
                                isReadOnly
                                isReturnOrder={false}
                            />
                        </Flex>
                    </Stack>
                </Box>
            </Flex>
            {showDivider && <Divider pt={remCalc(4)} />}
        </>
    )
}

SubscriptionCancelItemCard.propTypes = {
    item: PropTypes.object.isRequired,
    showDivider: PropTypes.bool,
}

export default SubscriptionCancelItemCard
